module.exports = __webpack_public_path__ + "static/media/ru_3.21df9f97.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Components/HelpDialogContent/ru_3.gif
// module id = 299
// module chunks = 3